import { AccommodationRequestFilterState } from "./accommodation-request-filter-state";
import { AccommodationRequestFilter } from "../hooks/use-accommodation-request-search-filters";
import { isEmpty } from "lodash";

export function mapFiltersToAccommodationRequestQueryInput(
  data: Partial<AccommodationRequestFilterState>
): AccommodationRequestFilter {
  const result: AccommodationRequestFilter = {};
  if (!isEmpty(data.text)) {
    result.text = data.text;
  }

  if (!isEmpty(data.responsiblePerson)) {
    result.responsibleUserIds = data.responsiblePerson;
  }

  if (!isEmpty(data.senderIds)) {
    result.senderIds = data.senderIds;
  }

  if (!isEmpty(data.accommodationRequestStatusFilter)) {
    result.status = data.accommodationRequestStatusFilter;
  }

  if (data.createdFromTo?.from) {
    result.from = data.createdFromTo.from || null;
  }

  if (data.createdFromTo?.to) {
    result.to = data.createdFromTo.to || null;
  }

  return result;
}
